window.dataLayer = window.dataLayer || [];

function createTagManager(gtmId) {
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  document.body.appendChild(script);
}

export default createTagManager;
